import { render, staticRenderFns } from "./projectArea.vue?vue&type=template&id=7e51138d&scoped=true&"
import script from "./projectArea.vue?vue&type=script&lang=js&"
export * from "./projectArea.vue?vue&type=script&lang=js&"
import style0 from "./projectArea.vue?vue&type=style&index=0&id=7e51138d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e51138d",
  null
  
)

export default component.exports